(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cb-kauf-v5-addons"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('cb-kauf-v5-addons')) return;

    class CbKaufV5Addons extends HTMLElement {
      connectedCallback() {
        this.cbBindInfo();

        if (this.dataset.cbInit) return;
        this.dataset.cbInit = '1';

        this.entries = [];

        if (window.CbKaufV5) this.cbAttach(window.CbKaufV5);
        else (window.CbKaufV5Queue = window.CbKaufV5Queue || []).push(this);
      }

      cbAttach(api) {
        if (this.attached) return;
        this.attached = true;

        var self = this;
        var addLabel = this.dataset.cbAddLabel || '';
        var addedLabel = this.dataset.cbAddedLabel || '';

        this.querySelectorAll('[data-cb-v5-card]').forEach(function (card) {
          var entry = {
            id: card.dataset.cbId,
            title: card.dataset.cbTitle || '',
            shortTitle: card.dataset.cbShort || card.dataset.cbTitle || '',
            image: card.dataset.cbImage || '',
            imageLarge: card.dataset.cbImageLarge || card.dataset.cbImage || '',
            description: card.dataset.cbDesc || '',
            price: Number(card.dataset.cbPrice || 0),
            kind: card.dataset.cbKind === 'qty' ? 'qty' : 'toggle',
            max: Number(card.dataset.cbMax || 1),
            qty: 0,
          };
          if (!entry.id) return;

          var toggle = card.querySelector('[data-cb-v5-toggle]');
          var label = card.querySelector('[data-cb-v5-toggle-label]');
          var mark = card.querySelector('[data-cb-v5-toggle-mark]');
          var value = card.querySelector('[data-cb-v5-value]');
          var minus = card.querySelector('[data-cb-v5-minus]');
          var plus = card.querySelector('[data-cb-v5-plus]');

          /* Die Karte malt sich aus dem Zustand, nicht aus ihrem Klick. Nur so stimmt sie auch
             dann, wenn die Menge aus der Leiste kommt. */
          entry.render = function (qty) {
            if (toggle) {
              toggle.setAttribute('aria-pressed', qty > 0 ? 'true' : 'false');
              if (label) label.textContent = qty > 0 ? addedLabel : addLabel;
              if (mark) mark.textContent = qty > 0 ? '✓' : '+';
            }
            if (value) value.textContent = String(qty);
            if (minus) minus.disabled = qty <= 0;
            if (plus) plus.disabled = qty >= api.limit(entry);
          };

          if (toggle) {
            toggle.addEventListener('click', function () {
              api.set(entry.id, api.get(entry.id) > 0 ? 0 : 1);
            });
          }
          if (minus) {
            minus.addEventListener('click', function () {
              api.step(entry.id, -1);
            });
          }
          if (plus) {
            plus.addEventListener('click', function () {
              api.step(entry.id, 1);
            });
          }

          self.entries.push(entry);
          api.register(entry);
        });
      }

      /* Info-Schublade. Die Listener hängen einmal am Block selbst (Delegation) und bleiben dort,
         auch wenn der Block beim Modellwechsel aus- und wieder eingehängt wird. */
      cbBindInfo() {
        if (this.cbInfoBound) return;
        this.cbInfoBound = true;

        var self = this;

        this.addEventListener('click', function (event) {
          var drawer = self.querySelector('[data-cb-v5-drawer]');
          if (!drawer) return;

          var trigger = event.target.closest('[data-cb-v5-info]');
          if (trigger) {
            self.cbOpenInfo(drawer, trigger);
            return;
          }
          /* Klick direkt auf das <dialog> ist ein Klick auf den Backdrop — das Panel deckt die
             Schublade sonst vollständig ab. */
          if (event.target === drawer || event.target.closest('[data-cb-v5-drawer-close]')) {
            self.cbCloseInfo(drawer);
          }
        });

        /* `cancel` (Escape) und `close` blubbern nicht, deshalb in der Capture-Phase. */
        this.addEventListener(
          'cancel',
          function (event) {
            if (!event.target.matches || !event.target.matches('[data-cb-v5-drawer]')) return;
            event.preventDefault();
            self.cbCloseInfo(event.target);
          },
          true
        );
        this.addEventListener(
          'close',
          function (event) {
            if (!event.target.matches || !event.target.matches('[data-cb-v5-drawer]')) return;
            self.cbReleaseInfo(event.target, true);
          },
          true
        );
      }

      cbOpenInfo(drawer, trigger) {
        if (typeof drawer.showModal !== 'function' || drawer.open) return;

        var title = drawer.querySelector('[data-cb-v5-drawer-title]');
        var text = drawer.querySelector('[data-cb-v5-drawer-text]');
        var media = drawer.querySelector('[data-cb-v5-drawer-media]');
        var img = drawer.querySelector('[data-cb-v5-drawer-img]');
        var panel = drawer.querySelector('[data-cb-v5-drawer-panel]');
        var src = trigger.dataset.cbInfoImage || '';

        if (title) title.textContent = trigger.dataset.cbInfoTitle || '';
        if (text) text.textContent = trigger.dataset.cbInfoText || '';
        if (img) {
          if (src) img.src = src;
          else img.removeAttribute('src');
          img.alt = trigger.dataset.cbInfoAlt || '';
        }
        if (media) media.hidden = !src;

        this.cbInfoTrigger = trigger;
        if (!this.cbInfoLocked) {
          this.cbInfoOverflow = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
          this.cbInfoLocked = true;
        }

        drawer.classList.remove('is-closing');
        drawer.showModal();
        if (panel) panel.scrollTop = 0;

        var close = drawer.querySelector('[data-cb-v5-drawer-close]');
        if (close) close.focus();
      }

      cbCloseInfo(drawer) {
        if (!drawer.open || drawer.classList.contains('is-closing')) return;

        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce) {
          drawer.close();
          return;
        }

        /* Erst hinausschieben, dann schließen — `close()` nimmt das Element sofort aus dem Bild. */
        drawer.classList.add('is-closing');
        window.setTimeout(function () {
          if (drawer.open) drawer.close();
          drawer.classList.remove('is-closing');
        }, 200);
      }

      cbReleaseInfo(drawer, restoreFocus) {
        if (drawer) drawer.classList.remove('is-closing');
        if (this.cbInfoLocked) {
          document.documentElement.style.overflow = this.cbInfoOverflow || '';
          this.cbInfoLocked = false;
        }
        var trigger = this.cbInfoTrigger;
        this.cbInfoTrigger = null;
        if (restoreFocus && trigger && trigger.isConnected) trigger.focus();
      }

      disconnectedCallback() {
        /* Beim Neu-Einsetzen der Section darf keine Scroll-Sperre hängen bleiben. */
        var drawer = this.querySelector('[data-cb-v5-drawer]');
        if (drawer && drawer.open) drawer.close();
        this.cbReleaseInfo(drawer, false);

        var api = window.CbKaufV5;
        if (api) {
          this.entries.forEach(function (entry) {
            api.unregister(entry.id);
          });
        }
        this.entries = [];
        this.attached = false;
        delete this.dataset.cbInit;
      }
    }

    customElements.define('cb-kauf-v5-addons', CbKaufV5Addons);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cb-kauf-v5-models"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('cb-kauf-v5-models')) return;

    var LEGACY_KEY = 'cb-kauf-v5-legacy-open';

    class CbKaufV5Models extends HTMLElement {
      connectedCallback() {
        if (this.dataset.cbInit) return;
        this.dataset.cbInit = '1';

        this.onClick = this.handleClick.bind(this);
        this.addEventListener('click', this.onClick);

        this.legacy = this.querySelector('[data-cb-legacy]');
        this.restoreLegacy();
        if (this.legacy) {
          this.onToggle = this.handleToggle.bind(this);
          this.legacy.addEventListener('toggle', this.onToggle);
        }

        if (window.CbKaufV5) this.cbAttach(window.CbKaufV5);
        else (window.CbKaufV5Queue = window.CbKaufV5Queue || []).push(this);

        this.applyView();
      }

      cbStore(key, value) {
        try {
          window.sessionStorage.setItem(key, value);
        } catch (error) {
          /* sessionStorage kann blockiert sein — dann eben ohne Gedaechtnis. */
        }
      }

      cbRead(key) {
        try {
          return window.sessionStorage.getItem(key);
        } catch (error) {
          return null;
        }
      }

      /* Der Aufklapper soll den Modellwechsel ueberleben: Der Tausch der Kaufspalte baut den
         Block neu auf, und wer gerade die Vorgaenger vergleicht, will sie nicht bei jedem
         Wechsel erneut aufklappen. Steht die eigene Seite selbst in der Gruppe, hat das
         serverseitige `open` Vorrang — der gemerkte Zustand darf sie nicht zuklappen und die
         als gewaehlt markierte Karte verstecken. */
      restoreLegacy() {
        if (!this.legacy || this.legacy.hasAttribute('data-cb-legacy-forced')) return;
        if (this.openFromNav()) return;
        if (this.cbRead(LEGACY_KEY) === '1') this.legacy.open = true;
      }

      /* Der Menuepunkt „Alle Modelle" verlinkt mit `?modelle=alle` hierher: Dann sollen die
         Vorgaenger sofort sichtbar sein, sonst zeigte die Seite nur zwei von allen Modellen.
         Der Zustand wird gemerkt, damit er den Tausch der Kaufspalte ueberlebt. Gescrollt wird
         nur beim ersten Aufbau und nur, wenn der Aufklapper unterhalb des Sichtfelds liegt —
         der Tausch baut den Block neu auf und darf die Seite nicht erneut springen lassen. */
      openFromNav() {
        var wanted = false;
        try {
          wanted = new URLSearchParams(window.location.search).get('modelle') === 'alle';
        } catch (error) {
          wanted = false;
        }
        if (!wanted || window.cbKaufV5AlleModelle) return false;
        window.cbKaufV5AlleModelle = true;

        this.legacy.open = true;
        this.cbStore(LEGACY_KEY, '1');
        var self = this;
        var legacy = this.legacy;
        window.requestAnimationFrame(function () {
          if (legacy.getBoundingClientRect().top <= window.innerHeight * 0.8) return;
          /* Auf den Blocktitel „Modell auswählen", mit Luft fuer die schwebende Navigation. */
          var top = self.getBoundingClientRect().top + window.scrollY - 96;
          window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
        });
        return true;
      }

      handleToggle() {
        if (!this.legacy) return;
        this.cbStore(LEGACY_KEY, this.legacy.open ? '1' : '0');
      }

      /* Der Modellblock traegt die Basisangaben: Er kommt beim Tausch der Kaufspalte mit und
         nennt dann Titel und Preis des neuen Modells. Laege das an der Buehne, zeigte die
         Leiste nach einem Wechsel weiter das alte Modell. */
      cbAttach(api) {
        api.setBase(
          this.dataset.baseTitle || '',
          this.dataset.basePrice || 0,
          this.dataset.baseImage || ''
        );
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        if (this.legacy && this.onToggle) this.legacy.removeEventListener('toggle', this.onToggle);
        delete this.dataset.cbInit;
      }

      /* Die Vorlage steht in der Adresse, nicht im Setting: Solange der Kaufbereich als
         Alternativvorlage lebt, traegt die URL `?view=kauf-v5` und die Karten muessen ihn
         weiterreichen; nach der Uebernahme in `product.campboks-*.json` traegt sie nichts, und
         ein festes `view=kauf-v5` zeigte auf eine geloeschte Vorlage. Darum werden die Ziele
         beim Aufbau nachgezogen — so stimmt auch der Mittelklick in einen neuen Tab. */
      applyView() {
        /* Bewusst ohne window.CbKaufV5: Der Block wird oft aufgebaut, bevor der Abschnitt die
           gemeinsame Schnittstelle setzt — dann blieben die Ziele nackt und ein Mittelklick
           landete auf der Agenturseite. */
        var view = '';
        try {
          view = new URLSearchParams(window.location.search).get('view') || '';
        } catch (error) {
          view = '';
        }
        if (!view) return;
        this.querySelectorAll('[data-cb-model-link]').forEach(function (card) {
          /* Vorgaengermodelle nicht: Sie werden normal aufgerufen (siehe `handleClick`) und
             liegen in ihren eigenen Vorlagen. Ein angehaengtes `?view=` schickte sie auf eine
             Alternativvorlage, die es fuer sie nicht gibt. */
          if (card.hasAttribute('data-cb-no-swap')) return;
          var url = card.getAttribute('data-cb-model-url');
          if (!url) return;
          card.setAttribute('href', url + '?view=' + encodeURIComponent(view));
        });
      }

      handleClick(event) {
        if (event.defaultPrevented || event.button !== 0) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        var target = event.target;
        var card = target && target.closest ? target.closest('[data-cb-model-link]') : null;
        if (!card || !this.contains(card)) return;

        /* Vorgaengermodelle werden nicht getauscht, sondern normal aufgerufen. Sie liegen in
           ihren eigenen Vorlagen ohne V5-Kaufspalte, und die Section Rendering API antwortet
           auch auf eine fremde Section-ID mit 200: sie rendert das Markup DIESER Vorlage mit
           den Daten der Zielseite. Der Tausch waere durchgelaufen und haette eine Seite
           hinterlassen, die es nicht gibt — Adresszeile /products/campboks-pro, daneben Hero
           und Features von Pro 2.0, und nach einem Reload etwas voellig anderes. */
        if (card.hasAttribute('data-cb-no-swap')) return;

        var api = window.CbKaufV5;
        if (!api || typeof api.switchModel !== 'function') return;

        event.preventDefault();
        api.switchModel({
          url: card.getAttribute('data-cb-model-url'),
          href: card.getAttribute('href'),
          title: card.getAttribute('data-cb-model-title'),
          card: card,
        });
      }
    }

    customElements.define('cb-kauf-v5-models', CbKaufV5Models);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cb-kauf-v5-price"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('cb-kauf-v5-price')) return;

    class CbKaufV5Price extends HTMLElement {
      connectedCallback() {
        if (this.dataset.cbInit) return;
        this.dataset.cbInit = '1';

        this.value = this.querySelector('[data-cb-v5-price-value]');
        this.onConfig = this.paint.bind(this);
        document.addEventListener('cb:config-change', this.onConfig);
        this.paint();
      }

      disconnectedCallback() {
        if (this.onConfig) document.removeEventListener('cb:config-change', this.onConfig);
        delete this.dataset.cbInit;
      }

      paint(event) {
        var api = window.CbKaufV5;
        if (!this.value || !api) return;
        var state = (event && event.detail) || api.getState();
        if (!state || !state.base) return;
        var text = api.money(state.base.price);
        if (this.value.textContent.trim() !== text) this.value.textContent = text;
      }
    }

    customElements.define('cb-kauf-v5-price', CbKaufV5Price);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cb-kauf-v5-title"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('cb-kauf-v5-title')) return;

    class CbKaufV5Title extends HTMLElement {
      connectedCallback() {
        if (this.dataset.cbInit) return;
        this.dataset.cbInit = '1';

        this.name = this.querySelector('[data-cb-v5-title-name]');
        this.onConfig = this.paint.bind(this);
        document.addEventListener('cb:config-change', this.onConfig);
        this.paint();
      }

      disconnectedCallback() {
        if (this.onConfig) document.removeEventListener('cb:config-change', this.onConfig);
        delete this.dataset.cbInit;
      }

      paint(event) {
        if (!this.name) return;
        var api = window.CbKaufV5;
        var state = (event && event.detail) || (api && api.getState());
        var title = state && state.base ? state.base.title : '';
        if (title && this.name.textContent !== title) this.name.textContent = title;
      }
    }

    customElements.define('cb-kauf-v5-title', CbKaufV5Title);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["image-hotspots"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const container = document.getElementById('hotspots');
    if (!container) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) animateHotspots();
        });
      },
      { threshold: 0.3 }
    );

    observer.observe(container);

    function animateOne(i) {
      const label = document.getElementById(`hotspot-label-${i}`);
      const target = document.getElementById(`hotspot-target-${i}`);
      const line = document.getElementById(`hotspot-line-${i}`);

      if (!label || !target || !line) return;

      const r1 = label.getBoundingClientRect();
      const r2 = target.getBoundingClientRect();
      const c = container.getBoundingClientRect();

      // Text-Ausrichtung bestimmen
      const align = window.getComputedStyle(label).textAlign;

      // LINE START: unten links oder unten rechts
      const startX = (align === 'right' ? r1.right : r1.left) - c.left;
      const startY = r1.bottom - c.top;

      // LINE END: Mittelpunkt des Zielpunkts
      const endX = r2.left + r2.width / 2 - c.left;
      const endY = r2.top + r2.height / 2 - c.top;

      const dx = endX - startX;
      const dy = endY - startY;
      const distance = Math.sqrt(dx * dx + dy * dy);
      const angle = Math.atan2(dy, dx) * (180 / Math.PI);

      line.style.top = startY + 'px';
      line.style.left = startX + 'px';
      line.style.transform = `rotate(${angle}deg)`;

      requestAnimationFrame(() => {
        line.style.width = distance + 'px';
        line.classList.add('visible');
      });
    }

    function animateHotspots() {
      animateOne(1);
      animateOne(2);
      animateOne(3);
      animateOne(4);
      animateOne(5);
      animateOne(6);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["social-proof"] && !Shopify.designMode) return;
  try {
    const container = document.querySelector('.js-sp-container');
  const rotator = container?.querySelector('.js-sp-avatar-rotator');

  if (container && rotator) {
    let interval = parseInt(container.dataset.rotation) || 3000;

    function updateClasses() {
      const avatars = Array.from(rotator.children);
      avatars.forEach((el, idx) => {
        el.classList.toggle('first', idx === 0);
      });
    }

    updateClasses();

    setInterval(() => {
      const avatars = Array.from(rotator.children);
      const current = avatars[0];

      current.classList.add('fade-out');

      setTimeout(() => {
        current.classList.remove('fade-out');
        rotator.appendChild(current);
        updateClasses();

        const incoming = rotator.lastElementChild;
        incoming.classList.add('fade-in');

        setTimeout(() => incoming.classList.add('active'), 20);

        setTimeout(() => {
          incoming.classList.remove('fade-in', 'active');
        }, 600);
      }, 500);
    }, interval);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tab-switcher"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-switcher]').forEach((switcher) => {
      console.log('switcher');
      const buttons = switcher.querySelectorAll('[data-switcher-button]');
      const panels = switcher.querySelectorAll('[data-switcher-panel]');

      buttons.forEach((btn) => {
        btn.addEventListener('click', () => {
          const id = btn.dataset.switcherButton;

          buttons.forEach((b) => b.classList.remove('active'));
          panels.forEach((p) => p.classList.remove('active'));

          btn.classList.add('active');
          switcher.querySelector(`[data-switcher-panel="${id}"]`).classList.add('active');
        });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
